import React, { useState, useEffect } from "react";
import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Drawer,
  List,
  ListItemText,
  ListItemButton,
  Badge,
  Box,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { logoutUser } from "../store/userSlice";
import { fetchPendingSalesCount } from "../store/salesSlice";
import { socket } from "../services/Api";
import { usePermissions } from "../services/PermissionsContext";

// Function to get drawer items based on permissions
const getDrawerItems = (permissions) => {
  if (!permissions?.routing) return []; // Vérifier si permissions est défini

  const { routing } = permissions; // Extraire la section "routing"
  const items = [];

  if (routing.canAccessDashboard) {
    items.push({ label: "Dashboard", path: "/Dashboard" });
  }
  if (routing.canAccessArticles) {
    items.push({ label: "Articles", path: "/Articles" });
  }
  if (routing.canAccessShop) {
    items.push({ label: "Shops", path: "/Shops" });
  }
 
  if (routing.canAccessCommande) {
    items.push({ label: "Commande", path: "/commande" });
  }
  if (routing.canAccessClientFournisseur) {
    items.push({ label: "Client Fournisseur", path: "/clientFournisseur" });
  }

  if (routing.canAccessUsers) {
    items.push({ label: "Utilisateurs", path: "/Users" });
  }
  if (routing.canAccessStockGenerale) {
    items.push({ label: "stock Generale", path: "/StockGenerale" });
  }

  return items;
};



export default function Navbar() {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const { permissions } = usePermissions(); // ✅ Hook is inside a React component now
  const { PendingSalesCount } = useSelector((state) => state.sale) || {};
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(fetchPendingSalesCount());

    socket.on("new-order", () => {
      dispatch(fetchPendingSalesCount());
    });

    return () => {
      socket.off("new-order");
    };
  }, [dispatch]);

  const toggleDrawer = (open) => () => {
    setDrawerOpen(open);
  };

  const handleOnClick = (path) => {
    navigate(path);
    toggleDrawer(false)();
  };

  const handleLogout = () => {
    dispatch(logoutUser());
    navigate("/");
  };

  const handleCommandeClick = () => {
    navigate("/commande");
  };

  // Retrieve user role from sessionStorage (if needed)
  const drawerItems = getDrawerItems(permissions); // ✅ Pass `permissions` to the function

  return (
    <>
      {/* Navbar */}
      <AppBar position="sticky">
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            aria-label="menu"
            onClick={toggleDrawer(true)}
            sx={{ mr: 2 }}
          >
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            Menu
          </Typography>

          {/* Shopping Cart Icon pushed to the right */}
          <Box sx={{ marginLeft: "auto" }}>
            <IconButton color="inherit" onClick={handleCommandeClick}>
              <Badge badgeContent={PendingSalesCount} color="secondary">
                <Typography>Commande</Typography>
                <ShoppingCartIcon />
              </Badge>
            </IconButton>
          </Box>
        </Toolbar>
      </AppBar>

      {/* Drawer */}
      <Drawer anchor="left" open={drawerOpen} onClose={toggleDrawer(false)}>
        <List sx={{ width: 250 }}>
          {drawerItems.map((item, index) => (
            <ListItemButton key={index} onClick={() => handleOnClick(item.path)}>
              <ListItemText primary={item.label} />
            </ListItemButton>
          ))}

          <ListItemButton onClick={handleLogout}>
            <ListItemText primary="Logout" style={{ color: "red" }} />
          </ListItemButton>
        </List>
      </Drawer>
    </>
  );
}
